module.exports = __webpack_public_path__ + "img/glassquality_6.07050227.png";